import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const TypographySection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Typography"
      description="Typography styles from the design system. Use SCSS mixins like @include body-regular;"
      figmaNodeId="2-909"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Display & Headings</h3>
      <div className={styles.typographyList}>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Display 1 (56px)</span>
          <span className={styles.display1}>The quick brown fox</span>
          <code className={styles.typographyCode}>@include display-1;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Heading 1 (48px)</span>
          <span className={styles.heading1}>The quick brown fox</span>
          <code className={styles.typographyCode}>@include heading-1;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Heading 2 (40px)</span>
          <span className={styles.heading2}>The quick brown fox</span>
          <code className={styles.typographyCode}>@include heading-2;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Heading 3 (28px)</span>
          <span className={styles.heading3}>The quick brown fox</span>
          <code className={styles.typographyCode}>@include heading-3;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Heading 4 (22px)</span>
          <span className={styles.heading4}>The quick brown fox</span>
          <code className={styles.typographyCode}>@include heading-4;</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Body Large (18px)</h3>
      <div className={styles.typographyList}>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Regular</span>
          <span className={styles.bodyLargeRegular}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include body-large-regular;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Medium</span>
          <span className={styles.bodyLargeMedium}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include body-large-medium;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Bold</span>
          <span className={styles.bodyLargeBold}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include body-large-bold;</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Body (16px)</h3>
      <div className={styles.typographyList}>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Regular</span>
          <span className={styles.bodyRegular}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include body-regular;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Medium</span>
          <span className={styles.bodyMedium}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include body-medium;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Bold</span>
          <span className={styles.bodyBold}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include body-bold;</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Body Small (14px)</h3>
      <div className={styles.typographyList}>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Regular</span>
          <span className={styles.bodySmallRegular}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include body-small-regular;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Medium</span>
          <span className={styles.bodySmallMedium}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include body-small-medium;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Bold</span>
          <span className={styles.bodySmallBold}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include body-small-bold;</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Caption & Metadata</h3>
      <div className={styles.typographyList}>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Caption Regular (13px)</span>
          <span className={styles.captionRegular}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include caption-regular;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Caption Medium (13px)</span>
          <span className={styles.captionMedium}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include caption-medium;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Metadata Regular (12px)</span>
          <span className={styles.metadataRegular}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include metadata-regular;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Metadata Medium (12px)</span>
          <span className={styles.metadataMedium}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include metadata-medium;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Metadata Small Regular (11px)</span>
          <span className={styles.metadataSmallRegular}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include metadata-small-regular;</code>
        </div>
        <div className={styles.typographyItem}>
          <span className={styles.typographyLabel}>Metadata Small Medium (11px)</span>
          <span className={styles.metadataSmallMedium}>The quick brown fox jumps over the lazy dog</span>
          <code className={styles.typographyCode}>@include metadata-small-medium;</code>
        </div>
      </div>
    </div>
  </section>
);
